import '../assets/NcBreadcrumb-eyloXKCC.css';
import { N as a } from "./NcActions-B1Ue3gj8.mjs";
import { G as o } from "./GenRandomId-BW3iYFf9.mjs";
import s from "../Components/NcButton.mjs";
import { C as i } from "./ChevronRight-DL3e8bjj.mjs";
import { n as u } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
const l = {
  name: "NcBreadcrumb",
  components: {
    NcActions: a,
    ChevronRight: i,
    NcButton: s
  },
  inheritAttrs: !1,
  props: {
    /**
     * The main text content of the entry.
     */
    name: {
      type: String,
      required: !0
    },
    /**
     * The title attribute of the element.
     */
    title: {
      type: String,
      default: null
    },
    /**
     * Route Location the link should navigate to when clicked on.
     *
     * @see https://v3.router.vuejs.org/api/#to
     */
    to: {
      type: [String, Object],
      default: void 0
    },
    /**
     * Match the complete route attributes (query and hash included)
     *
     * @see https://v3.router.vuejs.org/api/#exact
     */
    exact: {
      type: Boolean,
      default: !1
    },
    /**
     * Set this prop if your app doesn't use vue-router, breadcrumbs will show as normal links.
     */
    href: {
      type: String,
      default: void 0
    },
    /**
     * Set a css icon-class to show an icon along name text (if forceIconText is provided, otherwise just icon).
     */
    icon: {
      type: String,
      default: ""
    },
    /**
     * Enables text to accompany the icon, if the icon was provided. The text that will be displayed is the name prop.
     */
    forceIconText: {
      type: Boolean,
      default: !1
    },
    /**
     * Disable dropping on this breadcrumb.
     */
    disableDrop: {
      type: Boolean,
      default: !1
    },
    /**
     * Force the actions to display in a three dot menu
     */
    forceMenu: {
      type: Boolean,
      default: !1
    },
    /**
     * Open state of the Actions menu
     */
    open: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "update:open",
    "dropped"
  ],
  data() {
    return {
      /**
       * Variable to track if we hover over the breadcrumb
       */
      hovering: !1,
      /**
       * The unique id of the breadcrumb. Necessary to append the
       * Actions menu to the correct crumb.
       */
      crumbId: "crumb-id-".concat(o())
    };
  },
  computed: {
    /**
     * The attributes to pass to `router-link` or `a`
     */
    linkAttributes() {
      return this.to ? { to: this.to, exact: this.exact, ...this.$attrs } : this.href ? { href: this.href, ...this.$attrs } : this.$attrs;
    }
  },
  methods: {
    /**
     * Function to handle changing the open state of the Actions menu
     * $emit the open state.
     *
     * @param {boolean} open The open state of the Actions menu
     */
    onOpenChange(t) {
      this.$emit("update:open", t);
    },
    /**
     * Function to handle a drop on the breadcrumb.
     * $emit the event and the path, remove the hovering state.
     *
     * @param {object} e The drop event
     * @return {boolean}
     */
    dropped(t) {
      return this.disableDrop || (this.$emit("dropped", t, this.to || this.href), this.$parent.$emit("dropped", t, this.to || this.href), this.hovering = !1), !1;
    },
    /**
     * Add the hovering state on drag enter
     *
     * @param {object} e The drag enter event
     */
    dragEnter(t) {
      this.disableDrop || (this.hovering = !0);
    },
    /**
     * Remove the hovering state on drag leave
     *
     * @param {object} e The drag leave event
     */
    dragLeave(t) {
      this.disableDrop || t.target.contains(t.relatedTarget) || this.$refs.crumb.contains(t.relatedTarget) || (this.hovering = !1);
    }
  }
};
var c = function() {
  var e = this, r = e._self._c;
  return r("li", e._b({ ref: "crumb", staticClass: "vue-crumb", class: { "vue-crumb--hovered": e.hovering }, attrs: { draggable: "false" }, on: { dragstart: function(n) {
    return n.preventDefault(), (() => {
    }).apply(null, arguments);
  }, drop: function(n) {
    return n.preventDefault(), e.dropped.apply(null, arguments);
  }, dragover: function(n) {
    return n.preventDefault(), (() => {
    }).apply(null, arguments);
  }, dragenter: e.dragEnter, dragleave: e.dragLeave } }, "li", e._d({}, [e.crumbId, ""])), [(e.name || e.icon || e.$slots.icon) && !e.$slots.default ? r("NcButton", e._g(e._b({ attrs: { title: e.title, "aria-label": e.icon ? e.name : void 0, type: "tertiary" }, scopedSlots: e._u([e.$slots.icon || e.icon ? { key: "icon", fn: function() {
    return [e._t("icon", function() {
      return [r("span", { staticClass: "icon", class: e.icon })];
    })];
  }, proxy: !0 } : null, !(e.$slots.icon || e.icon) || e.forceIconText ? { key: "default", fn: function() {
    return [e._v(" " + e._s(e.name) + " ")];
  }, proxy: !0 } : null], null, !0) }, "NcButton", e.linkAttributes, !1), e.$listeners)) : e._e(), e.$slots.default ? r("NcActions", { ref: "actions", attrs: { type: "tertiary", "force-menu": e.forceMenu, open: e.open, "menu-name": e.name, title: e.title, "force-name": !0, container: ".vue-crumb[".concat(e.crumbId, "]") }, on: { "update:open": e.onOpenChange }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [e._t("menu-icon")];
  }, proxy: !0 }], null, !0) }, [e._t("default")], 2) : e._e(), r("ChevronRight", { staticClass: "vue-crumb__separator", attrs: { size: 20 } })], 1);
}, f = [], p = /* @__PURE__ */ u(
  l,
  c,
  f,
  !1,
  null,
  "fe4740ac",
  null,
  null
);
const v = p.exports;
export {
  v as N
};
